export default __webpack_public_path__ + "static/media/preview.5219b650.png";